<template>
  <el-dialog :title="'【' + modelParam.id + '】' + '任务信息'" center class="devOps-modelHead" :visible.sync="dialogVisible"
    width="80%" top="10px" :before-close="handleClose" :close-on-click-modal="false">
    <el-form size="mini" ref="form" :model="form" label-width="100px">
      <el-form-item label="标题">
        <el-input :disabled="step === 1" placeholder="请输入标题" v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="用户" prop="user">
        <el-select :disabled="step === 1" style="width: 100%" v-model="form.user" multiple filterable
          default-first-option placeholder="请输入用户">
          <el-option v-for="item in users" :key="item[1]" :label="item[0]" :value="item[1]">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述">
        <Editor dialogVisibleModelType="update" :disabled="step === 2" :content="form.describe"
          @contentData="changeEditContent" :placeholder="step === 2 ? '请输入' : ''" />
      </el-form-item>
      <el-form-item label="模块">
        <el-input :disabled="step === 1 || form.space !== 'developerSpace'" placeholder="请输入模块" v-model="form.module">
        </el-input>
      </el-form-item>
      <el-form-item label="项目地址">
        <el-input :disabled="step === 1" placeholder="请输入项目地址" v-model="form.project_url"></el-input>
      </el-form-item>
      <el-form-item label="优化级" prop="priority">
        <el-select style="width: 100%" v-model="form.priority" placeholder="请选择优化级" disabled v-show="step === 1">
        </el-select>
        <el-select style="width: 100%" v-model="form.priority" placeholder="请选择优化级" v-show="step === 2">
          <el-option v-for="(item, index) in prioritys" :key="index" :label="item[0]" :value="item[1]"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品" prop="user_pm">
        <el-select :disabled="step === 1" style="width: 100%" v-model="form.user_pm" filterable default-first-option
          placeholder="请输入产品">
          <el-option v-for="item in users" :key="item[1]" :label="item[0]" :value="item[1]">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计划上线时间" prop="plt">
        <el-date-picker :disabled="step === 1" style="width: 100%" v-model="form.plt" type="datetime"
          placeholder="请选择计划上线时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker disabled v-model="form.create_time" type="datetime" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="更新时间">
        <el-date-picker disabled v-model="form.update_time" type="datetime" placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button type="success" v-if="modelParam.later_state === 'pending' && modelParam.space === 'developerSpace'"
          @click="onSubmit('start')">进行开发</el-button>
        <el-button v-show="step === 1 && modelParam.space !== 'operatorSpace'" type="success" @click="step = 2">编辑
        </el-button>
        <el-button :disabled="runLoading" v-show="step === 2" type="primary" @click="onSubmit('run')">提交<i
            v-show="runLoading" class="el-icon-loading"></i></el-button>
        <el-button type="danger" :disabled="deleteLoading" v-if="modelParam.space === 'developerSpace'"
          @click="handleDetele">删除<i v-show="deleteLoading" class="el-icon-loading"></i></el-button>
        <el-button type="success" @click="handleClose">返回</el-button>
        <TipOne class="devOps-modelHead-tip" v-if="submitStatus" :status="submitStatus" :errorMsg="errorMsg" />
        <div class="errorMsg">{{ errorMessage }}</div>
      </div>
  </el-dialog>
</template>
<script>
import {
  postDevopsSpaceTaskUpdateApi,
  getDevOpsSpaceStageSelectmapApi,
  postDevOpsSpaceDeleteTaskApi,
  getDevOpsSpaceTaskDetailApi,
} from "@/server/tops/devOps";
import { Editor } from "@/components/index.js";
import { TipOne } from "../tips/index.js";
export default {
  components: { TipOne, Editor },
  props: {
    dialogVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: () => {
        return function () { };
      },
    },
    modelParam: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      form: {
        user: []
      },
      step: 1,
      submitStatus: "",
      prioritys: [],
      errorMsg: "",
      errorMessage: "",
      users: [],
      runLoading: false,
      deleteLoading: false,
    };
  },
  mounted() {
    this.form = {
      ...this.modelParam,
      project_url: this.modelParam.project_url || "",
    };
    this.queryDevOpsSpaceStageSelectmapApi();
    this.init();
  },
  methods: {
    async init() {
      const ret = await getDevOpsSpaceTaskDetailApi({
        id: this.modelParam.id || "",
        space: this.modelParam.space,
      });
      const info = ret.data[0] || {};
      this.form = {
        ...this.modelParam,
        ...info,
        user: info.user ? info.user.split(",") : [],
        user_pm: info.user_pm || '',
      };
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    changeEditContent(val) {
      this.form.describe = val;
    },
    handleDetele() {
      this.reset();
      this.$confirm("此操作将删除该任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.deleteLoading = true;
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: this.modelParam.id,
          });
          if (res.status === "success") {
            this.handleClose();
          } else {
            this.submitStatus = "error";
            this.errorMsg = "删除失败";
            this.errorMessage = res.data.msg || "";
          }
        } catch (error) { } finally {
          this.deleteLoading = false;
        }
      });
    },
    reset() {
      this.submitStatus = "";
      this.errorMsg = "";
      this.errorMessage = "";
    },
    handleClose() {
      this.hideDialogVisible("dialogVisible");
    },
    // 获取select
    async queryDevOpsSpaceStageSelectmapApi() {
      try {
        const ret = await getDevOpsSpaceStageSelectmapApi();
        this.prioritys = ret["devops-tasklist-priority"];
        this.users = ret["devops-tasklist-users"].map((item) => {
          item[0] = `${item[0]}（${item[1]}）`;
          return item;
        });
      } catch (error) {
        this.$notify({
          message: error || "获取select失败",
          type: "error",
        });
      }
    },
    async onSubmit(action) {
      try {
        this.reset();
        this.runLoading = true;
        const {
          id = "",
          title = "",
          user = [],
          describe = "",
          space = "",
          project_url = "",
          module = "",
          priority = "",
          user_pm = [],
          plt = "",
        } = this.form;
        const param = {
          id,
          title,
          user: user.toString(),
          describe,
          space,
          project_url,
          module,
          priority,
          user_pm: user_pm.toString(),
          plt,
        };
        action === 'start' && (param.coding = 'True');
        const ret = await postDevopsSpaceTaskUpdateApi(param);
        this.submitStatus = ret?.status === "success" ? "success" : "error";
        setTimeout(() => {
          if (this.submitStatus === 'success') this.handleClose()
        }, 1500);
      } catch (error) {
        this.$notify({
          message: error || "保存失败",
          type: "error",
        });
      } finally {
        this.runLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.devOps-modelHead {
  .devOps-modelHead-tip {
    margin-left: 16px;
  }
}
</style>
<style lang="scss">
.devOps-modelHead {
  .el-icon-loading {
    position: absolute;
    right: 5px;
  }

  .el-input__inner {
    font-size: 14px !important;
  }

  .el-button--mini {
    padding: 12px 20px;
    font-size: 14px;
  }

  .errorMsg {
    color: rgb(245, 108, 108);
    font-size: 16px;
  }

  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    font-weight: bold;
    padding: 20px 40px 10px;
  }

  .el-form-item__content .el-button {
    position: relative;
    letter-spacing: 2px !important;
    margin-left: 0;
    margin-right: 10px;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .el-dialog__title,
  .el-form-item__label,
  .el-button {
    font-weight: bold;
  }
}
</style>